module.exports = __webpack_public_path__ + "img/582592b3c2b7d.jpg_400x400.98d1300d.jpg";